import { Injectable } from '@angular/core';
import { WebSocketClient } from './websocket-client';

@Injectable()
export class WebSocketClientService extends WebSocketClient {
    
}